"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Entity_1 = require("../../Core/Entity");
var StoreEntity_1 = __importDefault(require("../../Core/StoreEntity"));
var FleetRouterEntity = /** @class */ (function (_super) {
    __extends(FleetRouterEntity, _super);
    function FleetRouterEntity(session) {
        return _super.call(this, {
            session: session,
            entityName: 'fleet_router',
            routeSuffix: 'routing_rules',
            routes: [Entity_1.BaseRoutes.Create, Entity_1.BaseRoutes.Delete, Entity_1.BaseRoutes.Update, Entity_1.BaseRoutes.GetAll, Entity_1.BaseRoutes.Patch]
        }) || this;
    }
    return FleetRouterEntity;
}(StoreEntity_1.default));
exports.default = FleetRouterEntity;
//# sourceMappingURL=FleetRouterEntity.js.map